import { Suspense } from "react";
import { Outlet } from "react-router-dom";

import { BootMark } from "~/components/BootMark.tsx";

const RootPage: React.FC = () => {
	return (
		<div className="flex h-screen items-center justify-center font-normal">
			<Suspense fallback={<BootMark />}>
				<Outlet />
			</Suspense>
		</div>
	);
};

export default RootPage;
